import css from 'styled-jsx/css';

export const staticStyles = css`
  .ActionsTab {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
  }
  .ActionsTab__filters-left { display: flex; align-items: center; flex: 1; gap: 12px; min-width: 260px; }
  @media (max-width: 600px) {
    .ActionsTab__filters-left { width: 100%; }
  }
`;
